// Б.2.d: Закалённый кибер-псих — триггер «любой юнит на поле получил урон».
//
// Каждый раз, когда ЛЮБОЙ юнит на поле боя (свой или вражеский, любой линии)
// получает урон > 0, Закалённый получает +1 атаки и +1 Брони.
//
// Не реагирует на:
//   - урон по Героям (только по юнитам).
//   - юнита в Режиме ожидания (пассивки в спящем режиме отключены, диздок 6.6).
//
// Бонусы стакаются без потолка. Включая урон по самому Закалённому.

export const CARD_ID = 'syn_zakalennyy_kiber_psih';

// Вызывается из notifyCharacterDamaged (или напрямую из applyDamage-точек),
// когда юнит victim получил dmg урона.
//   victimOwnerIdx — на чьей стороне находится victim.
//   victim         — Card (тип 'unit').
//   dmg            — фактический урон по HP+броне.
export function zakalennyyOnAnyUnitDamaged(state, victimOwnerIdx, victim, dmg) {
  if (!victim || victim.type !== 'unit') return;     // только юниты
  if (dmg <= 0) return;
  // Проходим по обоим игрокам — Закалённый может быть у каждого.
  for (let idx = 0; idx < 2; idx++) {
    const p = state.players[idx];
    for (const u of p.unitsOnField()) {
      if (u.id !== CARD_ID) continue;
      if (u.isSleeping(state.currentTurn)) continue;
      // Бонусы: +1 atk, +1 armor (постоянные).
      u.current.atk   += 1;
      u.current.armor += 1;
      u.persistentArmor    = (u.persistentArmor    || 0) + 1;
      u.persistentMaxArmor = (u.persistentMaxArmor || 0) + 1;
      state.log.add(
        `🔋 ${u.name_ru} [${p.name}]: +1/+1/0 (юнит получил урон) ` +
        `→ ${u.current.atk}/${u.current.armor}/${u.current.hp}`
      );
    }
  }
}
